export const URL_PORTAL = 'https://aluno.alunoensina.com';
export const PORTAL_STUDENT = 'https://aluno.alunoensina.com';
export const PORTAL_TEACHER = 'https://teacher.alunoensina.com';
export const PORTAL_ADMIN = 'https://admin.alunoensina.com';


